<ion-chip
  [color]="agreementStatus | agreementStatusColor"
  data-testid="agreement-status-chip"
>
  <ion-icon
    [name]="statusIcon"
    *ngIf="agreementStatus | agreementStatusChipIcon as statusIcon"
  ></ion-icon>
  {{ agreementStatus | agrStatusMap | titlecase }}
</ion-chip>
